import { Router } from 'vue-router'
import { useAppStore } from '@/modules/app/app.store'
import config from '@/config'

export default {
  handler(router: Router, error: any) {
    const accountID = useAppStore().accountID
    const billingUrl = `${config.serverSideAppUrl}/app/${accountID}/account/billing-information`
    window.location.href = billingUrl
  },
}
